import { render, staticRenderFns } from "./productItemDescription.vue?vue&type=template&id=797cedf0&"
import script from "./productItemDescription.vue?vue&type=script&lang=js&"
export * from "./productItemDescription.vue?vue&type=script&lang=js&"
import style0 from "./productItemDescription.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports